import { useState } from "react";
import Layout from "../../../components/custom/Layout";
import { Nav } from "reactstrap";
import CustomNavItem from "../../../components/custom/CustomNavItem";
import { TabContent } from "reactstrap";
import CustomTabPane from "../../../components/custom/CustomTabPane";
import UnitedLogs from "./UnitedLogs";

export type Tab = 'UNITED_API';

export default function DevLogs() {

    const [activeTab, setActiveTab] = useState<Tab>('UNITED_API');

    const toggleTab = (tab: Tab) => setActiveTab(tab);

    return (
        <Layout>
            <Nav tabs className={'separator-tabs'}>
                <CustomNavItem<Tab>
                    tabName="UNITED API"
                    tabId="UNITED_API"
                    activeTabId={activeTab}
                    toggleTab={toggleTab}
                />
            </Nav>
            <TabContent activeTab={activeTab} className={'mt-2'}>
                <CustomTabPane<Tab> tabId={'UNITED_API'}>
                    <UnitedLogs tab={activeTab} />
                </CustomTabPane>
            </TabContent>
        </Layout>
    );
}